import { datadogRum } from "@datadog/browser-rum";
import PerformanceLogger from "helpers/performanceHelper";
import { camelCase } from "lodash";
import { Actions } from "../actions";
import { CustomAttributes, MonitoredEventTypes } from "../types";

export const trackAction = (action: Actions, context?: CustomAttributes) => {
  datadogRum.addAction(action, {
    ...context,
    type: MonitoredEventTypes.ACTION,
  });
  datadogRum.addTiming(camelCase(action)); // default sanitization method for datadog.
};

export const trackActionStart = (startAction: Actions, id?: string) => {
  PerformanceLogger.start(startAction, id);
};

export const trackActionEnd = (
  startAction: Actions,
  action?: Actions,
  context?: CustomAttributes,
  id?: string,
  // eslint-disable-next-line max-params
) => {
  const duration = PerformanceLogger.end(startAction, id);

  const recordedAction = action || startAction;

  if (duration) {
    datadogRum.addAction(recordedAction, {
      ...context,
      [camelCase(recordedAction)]: duration,
      type: MonitoredEventTypes.TIMING,
    });
    datadogRum.addTiming(camelCase(action));
  }
};
